import { useEffect, useState } from 'react';
import { post, setToken } from '../api';
import { Button, TextField } from '../components/ui';
import { BrandLogo } from '../components/brand';
import type { User } from '../auth';

export default function Login({ onLogin }: { onLogin: (u: User) => void }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);
  const [sandbox, setSandbox] = useState(false);
  useEffect(() => { fetch('/health').then((r) => r.json()).then((h) => setSandbox(h.mode === 'sandbox')).catch(() => undefined); }, []);
  const submit = async (e: React.FormEvent) => {
    e.preventDefault(); setBusy(true); setError(null);
    try { const r = await post<{ token: string; user: User }>('/auth/login', { email, password }); setToken(r.token); onLogin(r.user); }
    catch (err: any) { setError(err.message); } finally { setBusy(false); }
  };
  return (
    <div className="login">
      <section className="login-art" aria-hidden="true">
        <div className="row" style={{ gap: 14 }}><BrandLogo height={38} /><span style={{ color: '#E4D9C5', fontSize: '1.1rem' }}>Assist</span></div>
        <div><h1>Every comment and DM, answered well.</h1><p>Instagram, Facebook, website chat, and email in one inbox, with a compliance check on every reply.</p></div>
        <div className="ruler-art" />
      </section>
      <section className="login-form">
        <form onSubmit={submit} noValidate>
          <h2>Sign in</h2>
          <TextField label="Work email" type="email" value={email} onChange={setEmail} autoFocus />
          <TextField label="Password" type="password" value={password} onChange={setPassword} />
          {error && <div className="note error" role="alert">{error}</div>}
          <Button variant="primary" loading={busy} disabled={!email || !password}>Sign in</Button>
          {sandbox && <div className="note info">Sandbox mode. Default login: admin@truheight.local with password truheight-sandbox. Change it before going live.</div>}
        </form>
      </section>
    </div>
  );
}
